// React
import React, { Component } from "react";

// Components
import { SignupTab, LoginTab } from './';

import './loginpanel.css';

/**********************************************************
 *    Login Panel Component
 * 
 *  - Validates the inputs for login/signup
 *  - Facilitates the login/signup process
 * 
 **********************************************************/

export class LoginPanel extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/

    constructor(props) {

        super(props);

        this.state = {
            userIcon : 'icon-user ',
            username : '',
            password : '',
            email : '',
            message : null,
            activeTab : 'login'
        };
    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render
    componentDidMount() {

        //console.log('LoginPanel.componentDidMount()');
    }

    // Displays a message box on login panel with given parameters
    displayMessage(title, details, type) {

        const msg = {
            title : title,
            details : details,
            type : type
        };

        this.setState((prevState,props) => {
            return {
                message : msg
            }
        });

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Cache the newly selected tab
    switchTab(newTab) {

        this.setState((prevState,props) => {
            return {
                activeTab : newTab
            }
        });

    }

/**********************************************************
 *  Render
 **********************************************************/

  // Renders the LoginPanel Component with children:
  // LoginPanelSettings and Pricer
  render() {

    var tab = (<LoginTab history={this.props.history} />);

    if(this.state.activeTab === 'signup') {
        tab = (<SignupTab history={this.props.history} />);
    }

    return (            
        
        <div className="panel panel-flat signup-panel bg-theme-500">

                {/*<h5 className="panel-title">{this.props.title === 'Signup' ? "Signup for Free" : this.props.title}</h5>*/}
            <div className="panel-top-menu">

                <div className={this.state.activeTab === 'login' ? 'tab-button left-tab active' : 'tab-button left-tab'} 
                onClick={() => this.switchTab('login')} style={{width:'40%'}}>LOGIN</div>
                <div className={this.state.activeTab === 'signup' ? 'tab-button right-tab active' : 'tab-button right-tab'} 
                onClick={() => this.switchTab('signup')} style={{width:'60%'}}>SIGNUP <div className="soon">open beta</div></div>
            </div>


            {/*--- body ---*/}
            <div className="panel-body">

                { tab }

            </div>
            {/*--- / body ---*/}

        </div>

    );
  }
};



// WEBPACK FOOTER //
// ./src/Views/Login/LoginPanel.js